export interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
  redirectUri: string;
}

// Valida se todas as variáveis de ambiente necessárias estão definidas
const validateEnvVars = () => {
  const requiredVars = [
    "REACT_APP_KEYCLOAK_URL",
    "REACT_APP_KEYCLOAK_REALM",
    "REACT_APP_KEYCLOAK_CLIENT_ID",
  ];

  const missingVars = requiredVars.filter((varName) => !process.env[varName]);

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables for Keycloak configuration: ${missingVars.join(
        ", "
      )}\n` +
        "Please check your .env file and ensure all Keycloak variables are set."
    );
  }
};

validateEnvVars();

export const keycloakConfig: KeycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL!,
  realm: process.env.REACT_APP_KEYCLOAK_REALM!,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID!,
  redirectUri:
    process.env.REACT_APP_KEYCLOAK_REDIRECT_URI || window.location.origin,
};

export const keycloakUrls = {
  auth: `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/auth`,
  token: `${process.env.REACT_APP_REDEFROTA_SSO_URL}/api/oauth/token`,
  userInfo: `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/userinfo`,
  logout: `${process.env.REACT_APP_REDEFROTA_SSO_URL}/api/oauth/session`,
};
